// extracted by mini-css-extract-plugin
export default {"input_area":"loginForm_input_area__Oyvab","big_logo":"loginForm_big_logo__UExYG","button":"loginForm_button__oz2MQ"};